<template>
  <div class="profile standardpage">
    <b-card>
      <b-card-header>
        <CIcon :name="icon" />
        {{ title }}
      </b-card-header>
      <b-card no-body class="border-none">
        <!--  <div class="">
          <div class="p-2 text-center">
            <div class="picture-container">
              <div class="picture_avatar">
                <div v-if="!avatar">
                  <img
                    :src="user.avatar ? user.avatar.url : ''"
                    class="avatar-src"
                    :title="user.name"
                  />
                </div>
                <div v-else>
                  <img :src="avatar" class="avatar-src" />
                </div>
                <input type="file" @change="onAvatarChange" />
              </div>
              <b-link @change="onAvatarChange">Choose Picture</b-link>
            </div>
            <b-link @click="removeImage('avatar')">Remove</b-link>
            <h3 class="text-muted">{{ user.name }}</h3>
          </div>
        </div> -->
      </b-card>
      <b-row class="justify-content-md-left">
        <b-col cols="12" sm="9">
          <b-card>
            <b-tabs
              pills
              card
              vertical
              nav-wrapper-class="w-100 w-sm-26 border-right"
            >
              <b-tab active>
                <template #title>
                  <i class="fa fa-user-circle mr-1"></i> Avatar
                </template>
                <b-card-text>
                  <h4 class="mb-4 text-center">Avatar Settings</h4>
                  <b-card no-body class="border-none">
                    <div class="profile-tab-nav">
                      <div class="p-4 text-center">
                        <div class="picture-container">
                          <div class="picture_avatar">
                            <div v-if="!user.avatarb64">
                              <img
                                :src="user.avatarb64 ? user.avatarb64.url : ''"
                                class="avatar-src"
                                :title="user.name"
                              />
                            </div>
                            <div v-else>
                              <img
                                style="width: 106px; height: 106px"
                                :src="user.avatarb64"
                                class="avatar-src"
                              />
                            </div>

                            <input type="file" @change="onAvatarChange" />
                          </div>
                          <!-- <b-link @change="onAvatarChange"
                            >Choose Picture</b-link
                          > -->
                        </div>

                        <!-- <b-row class="my-2">
                          <b-col>
                            <div class="row">
                              <div class="col s12">
                                <div
                                  class="
                                    fileuploader
                                    center-align
                                    text-center text-primary
                                  "
                                  @dragover="dragover"
                                  @dragleave="dragleave"
                                  @drop="drop"
                                >
                                  <input
                                    type="file"
                                    multiple
                                    name="fields[assetsFieldHandle][]"
                                    id="assetsFieldHandle"
                                    class="
                                      w-px
                                      h-px
                                      opacity-0
                                      overflow-hidden
                                      absolute
                                    "
                                    @change="onChange"
                                    ref="file"
                                    style="display: none"
                                    accept=".hot"
                                  />
                                  <label
                                    for="assetsFieldHandle"
                                    class="block cursor-pointer"
                                  >
                                    <div id="upload-label" class="font-2x">
                                      <i class="fa fa-cloud-upload"></i>
                                    </div>

                                    <span class="tittle"
                                      >Click the icon or drop files here to
                                      upload a new avatar</span
                                    >
                                  </label>
                                </div>
                              </div>
                            </div>
                          </b-col>
                        </b-row> -->

                        <b-link @click="removeImage('avatarb64')"
                          >Remove</b-link
                        >

                        <h3 class="text-muted">{{ user.name }}</h3>
                        <div class="text-muted">
                          Last Login: {{ item.lastlogin }}
                        </div>
                      </div>
                    </div>
                  </b-card>
                </b-card-text>
              </b-tab>
              <b-tab>
                <template #title>
                  <i class="fa fa-user mr-1"></i> Account
                </template>
                <b-card-text>
                  <h4 class="mb-4 text-center">Account Settings</h4>
                  <b-card class="border-none">
                    <!-- <b-form> -->
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Email"
                          label-for="email"
                          label-cols="12"
                          label-size="sm"
                        >
                          <b-input-group>
                            <b-form-input
                              id="email"
                              type="email"
                              size="sm"
                              v-model="item.email"
                              :placeholder="user.email"
                              disabled
                              :debounce="options.debounce"
                            ></b-form-input>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Title"
                          label-for="title"
                          label-cols="12"
                          label-size="sm"
                        >
                          <b-input-group>
                            <b-form-input
                              list="title-list-id"
                              id="title"
                              type="text"
                              size="sm"
                              :debounce="options.debounce"
                              v-model="item.title"
                              placeholder="Enter title"
                              @keyup.native="isChanged()"
                              :disabled="readonly"
                            ></b-form-input>
                            <datalist id="title-list-id">
                              <option v-for="title in titles" :key="title">
                                {{ title }}
                              </option>
                            </datalist>
                            <b-form-invalid-feedback
                              >Title: Required</b-form-invalid-feedback
                            >
                            <b-input-group-append>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                :disabled="!item.title"
                                @click="item.title = ''"
                              >
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Firstname"
                          label-for="firstname"
                          label-cols="12"
                          label-size="sm"
                        >
                          <b-input-group>
                            <b-form-input
                              id="firstname"
                              type="text"
                              size="sm"
                              v-model="item.firstname"
                              :debounce="options.debounce"
                              placeholder="Enter firstname"
                              @keyup.native="isChanged()"
                              :disabled="readonly"
                            ></b-form-input>

                            <b-form-invalid-feedback
                              >Firstname: Required</b-form-invalid-feedback
                            >
                            <b-input-group-append>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                :disabled="!item.firstname"
                                @click="item.firstname = ''"
                              >
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Lastname"
                          label-for="lastname"
                          label-cols="12"
                          label-size="sm"
                        >
                          <b-input-group>
                            <b-form-input
                              id="lastname"
                              type="text"
                              size="sm"
                              v-model="item.lastname"
                              placeholder="Enter lastname"
                              :debounce="options.debounce"
                              @keyup.native="isChanged()"
                              :disabled="readonly"
                            ></b-form-input>

                            <b-form-invalid-feedback
                              >Lastname: Required</b-form-invalid-feedback
                            >
                            <b-input-group-append>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                :disabled="!item.lastname"
                                @click="item.lastname = ''"
                              >
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group> </b-col
                    ></b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Mobile for One Time Passcodes"
                          label-for="mobile"
                          label-cols="12"
                          label-size="sm"
                        >
                          <b-input-group>
                            <b-2fa
                              label=" Cell Phone"
                              v-model="item.mobile"
                              size="sm"
                              :darkmode="$store.state.darkMode"
                              placeholder="Cell Phone"
                              :debounce="options.debounce"
                              @keyup.native="isChanged()"
                              class="w-100pct"
                            />
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-card-text>
              </b-tab>
              <b-tab>
                <template #title>
                  <i class="fa fa-key mr-1"></i> Password
                </template>
                <b-card-text>
                  <h4 class="mb-4 text-center">Password Settings</h4>
                  <b-card class="border-none">
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Old Password"
                          label-for="password_old"
                          label-cols="12"
                          label-size="sm"
                          ><b-input-group>
                            <b-form-input
                              id="password_old"
                              type="password"
                              size="sm"
                              v-model="password_old"
                              :state="password_old_valid"
                              placeholder="<type old passsword>"
                              @keyup.native="isChanged()"
                              autocomplete="old-password"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                :disabled="!password_old"
                                @click="password_old = ''"
                              >
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="New Password"
                          label-for="password_new1"
                          label-cols="12"
                          label-size="sm"
                          ><b-input-group>
                            <b-form-input
                              id="password_new1"
                              type="password"
                              size="sm"
                              v-model="password_new1"
                              :state="password_new1_valid"
                              placeholder="<type new passsword>"
                              @keyup.native="isChanged()"
                              autocomplete="new-password"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                :disabled="!password_new1"
                                @click="password_new1 = ''"
                              >
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Retype New Password"
                          label-for="password_new2"
                          label-cols="12"
                          label-size="sm"
                          ><b-input-group>
                            <b-form-input
                              id="password_new2"
                              type="password"
                              size="sm"
                              v-model="password_new2"
                              :state="password_new2_valid"
                              placeholder="<retype new passsword>"
                              @keyup.native="isChanged()"
                              autocomplete="new-password"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button
                                size="sm"
                                variant="outline-secondary"
                                :disabled="!password_new2"
                                @click="password_new2 = ''"
                              >
                                <i class="fa fa-remove"></i>
                              </b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-card-text>
              </b-tab>
              <b-tab>
                <template #title>
                  <i class="fa fa-user-secret mr-1"></i> Security
                </template>
                <b-card-text>
                  <h4 class="mb-4 text-center">Security Settings</h4>
                  <b-card class="border-none">
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Status"
                          label-for="status"
                          label-cols="12"
                          label-size="sm"
                        >
                          <treeselect
                            instanceId="status"
                            type="number"
                            v-model="item.status"
                            disabled
                            :clearable="false"
                            :options="[
                              { label: 'Registered', id: 0 },
                              { label: 'Invited', id: 1 },
                              { label: 'Created', id: 2 },
                              { label: 'Disabled', id: 9 },
                            ]"
                          ></treeselect> </b-form-group
                      ></b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Date Invited"
                          label-for="dateinvited"
                          label-cols="12"
                          label-size="sm"
                        >
                          <b-input-group>
                            <b-form-input
                              id="dateinvited"
                              type="text"
                              size="sm"
                              v-model="item.invited"
                              disabled
                            ></b-form-input>
                          </b-input-group> </b-form-group
                      ></b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="UID"
                          label-for="uid"
                          label-cols="12"
                          label-size="sm"
                        >
                          <b-input-group>
                            <b-form-input
                              id="uid"
                              type="text"
                              size="sm"
                              v-model="item.id"
                              disabled
                            ></b-form-input>
                          </b-input-group> </b-form-group
                      ></b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label="Role"
                          label-for="role"
                          label-cols="12"
                          label-size="sm"
                        >
                          <b-input-group>
                            <b-form-input
                              id="role"
                              type="text"
                              size="sm"
                              v-model="user.rolename"
                              disabled
                            ></b-form-input>
                          </b-input-group> </b-form-group
                      ></b-col>
                    </b-row>
                  </b-card>
                </b-card-text>
              </b-tab>
              <b-tab v-if="user.rolename != 'client'">
                <template #title>
                  <i class="fa fa-desktop mr-1"></i> Desktop
                </template>
                <b-card-text>
                  <h4 class="mb-4 text-center">Desktop Settings</h4>
                  <b-card class="border-none">
                    <b-row>
                      <b-col cols="6"
                        ><div class="clearfix mt-4">
                          <small>
                            <b>Notifications Check</b>
                          </small>
                          <div class="mt-2">
                            <b-card no-body class="bg-success">
                              <b-card-body class="pb-0 pt-0 pr-2">
                                <b-dropdown
                                  class="float-right"
                                  variant="transparent p-0"
                                  right
                                >
                                  <template slot="button-content">
                                    <i class="icon-clock"></i>
                                  </template>
                                  <b-dropdown-item
                                    v-for="beat in beats"
                                    :key="beat"
                                    @click="handleUpdate({ beats: beat })"
                                    :active="userbeat == beat"
                                    >{{ beat }}</b-dropdown-item
                                  >
                                </b-dropdown>
                                <p class="mb-0">Every {{ userbeat }}sec</p>
                              </b-card-body>
                            </b-card>
                          </div>
                        </div></b-col
                      >
                    </b-row>
                    <b-row>
                      <b-col cols="6"
                        ><div class="clearfix mt-4">
                          <small>
                            <b>Default rows per grid</b>
                          </small>
                          <div class="mt-2">
                            <b-card no-body class="bg-success">
                              <b-card-body class="pb-0 pt-0 pr-2">
                                <b-dropdown
                                  class="float-right"
                                  variant="transparent p-0"
                                  right
                                >
                                  <template slot="button-content">
                                    <i class="icon-list"></i>
                                  </template>
                                  <b-dropdown-item
                                    v-for="(row, index) in rows"
                                    :key="index"
                                    @click="handleUpdate({ perpage: row })"
                                    :active="user.perpage == row"
                                    >{{ row }}</b-dropdown-item
                                  >
                                </b-dropdown>
                                <p class="mb-0">
                                  Rows per grid {{ user.perpage }}
                                </p>
                              </b-card-body>
                            </b-card>
                          </div>
                        </div></b-col
                      >
                    </b-row>
                  </b-card>
                  <!-- <b-card no-body class="border-none">
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label-cols="12"
                          label="Event"
                          label-size="sm"
                        >
                          <treeselect
                            placeholder="Select event..."
                            searchPromptText="Type at least 3 chars..."
                            v-model="eventcode"
                            :clearable="true"
                            :async="true"
                            :load-options="treeselect_loadEvent"
                            :show-count="true"
                            :flatten-search-results="true"
                            :disable-branch-nodes="true"
                            :matchKeys="['id']"
                            search-nested
                          >
                            <div slot="value-label" slot-scope="{ node }">
                              {{ node.raw.id }}
                            </div>
                          </treeselect>
                        </b-form-group>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-group
                          label-cols="12"
                          label="Client SL A/C"
                          label-size="sm"
                        >
                          <treeselect
                            placeholder="Select slac..."
                            searchPromptText="Type at least 3 chars..."
                            v-model="slac"
                            :clearable="true"
                            :async="true"
                            :load-options="treeselect_loadSLAC"
                            :show-count="true"
                            :flatten-search-results="true"
                            :disable-branch-nodes="true"
                            :matchKeys="['id']"
                            search-nested
                            :disabled="
                              user.rolename == 'api' ||
                              user.rolename == 'client'
                            "
                          >
                            <div slot="value-label" slot-scope="{ node }">
                              {{ node.raw.id }}
                            </div>
                          </treeselect>
                        </b-form-group>
                      </b-col>
                    </b-row>
                  </b-card> -->
                </b-card-text>
              </b-tab>
              <b-tab>
                <template #title>
                  <i class="fa fa-home mr-1"></i> Company
                </template>
                <b-card-text>
                  <h4 class="mb-4 text-center">Company</h4>
                  <b-card class="border-none">
                    <form>
                      <b-row class="mb-2">
                        <b-col cols="12">
                          <b-form-group
                            label="Company"
                            label-for="companyname"
                            label-cols="12"
                            label-size="sm"
                          >
                            <b-input-group>
                              <b-form-input
                                id="company"
                                type="text"
                                size="sm"
                                v-model="item.company"
                                placeholder="Enter company name"
                                @keyup.native="isChanged()"
                                :disabled="readonly"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  size="sm"
                                  variant="outline-secondary"
                                  :disabled="!item.company"
                                  @click="item.company = ''"
                                >
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row class="mb-2">
                        <b-col cols="12">
                          <b-form-group
                            label="Phone"
                            label-for="telephone"
                            label-cols="12"
                            label-size="sm"
                          >
                            <b-2fa
                              label="Phone"
                              size="sm"
                              v-model="item.companytelephone"
                              :darkmode="$store.state.darkMode"
                              placeholder="Telephone"
                              @keyup.native="isChanged()"
                            />
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row class="mb-2">
                        <b-col cols="12">
                          <b-form-group
                            label="Extension"
                            label-for="extension"
                            label-cols="12"
                            label-size="sm"
                          >
                            <b-input-group>
                              <b-form-input
                                id="extension"
                                type="text"
                                size="sm"
                                v-model="item.extension"
                                placeholder="Enter extension"
                                @keyup.native="isChanged()"
                                :disabled="readonly"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  size="sm"
                                  variant="outline-secondary"
                                  :disabled="!item.extension"
                                  @click="item.extension = ''"
                                >
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row class="mb-2">
                        <b-col cols="12">
                          <b-form-group
                            label="Department"
                            label-for="department"
                            label-cols="12"
                            label-size="sm"
                          >
                            <b-input-group>
                              <b-form-input
                                id="department"
                                type="text"
                                size="sm"
                                v-model="item.department"
                                placeholder="Enter department"
                                @keyup.native="isChanged()"
                                :disabled="readonly"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  size="sm"
                                  variant="outline-secondary"
                                  :disabled="!item.department"
                                  @click="item.department = ''"
                                >
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>

                      <b-row class="mb-2">
                        <b-col cols="12">
                          <b-form-group
                            label="Job Title"
                            label-for="jobtitle"
                            label-cols="12"
                            label-size="sm"
                          >
                            <b-input-group>
                              <b-form-input
                                id="jobtitle"
                                type="text"
                                size="sm"
                                v-model="item.jobtitle"
                                placeholder="Enter jobtitle"
                                @keyup.native="isChanged()"
                                :disabled="readonly"
                              ></b-form-input>
                              <b-input-group-append>
                                <b-button
                                  size="sm"
                                  variant="outline-secondary"
                                  :disabled="!item.jobtitle"
                                  @click="item.jobtitle = ''"
                                >
                                  <i class="fa fa-remove"></i>
                                </b-button>
                              </b-input-group-append>
                            </b-input-group>
                          </b-form-group>
                        </b-col>
                      </b-row>
                    </form>
                  </b-card> </b-card-text
              ></b-tab>
              <b-tab v-if="user.rolename != 'client'">
                <template #title>
                  <i class="fa fa-plane mr-1"></i> Travel
                </template>
                <b-card-text>
                  <h4 class="mb-4 text-center">Travel Settings</h4>
                  <b-card class="border-none">
                    <b-row class="mb-2">
                      <b-col cols="12">
                        <b-form-textarea
                          id="textarea-small"
                          v-model="item.alternativenames"
                          placeholder="Alternative Names"
                          rows="8"
                          no-resize
                        ></b-form-textarea>
                      </b-col>
                    </b-row>
                  </b-card>
                </b-card-text>
              </b-tab>
            </b-tabs>
          </b-card>
        </b-col>
      </b-row>

      <b-card-footer class="mt-0">
        <b-row>
          <b-col class="text-left">
            <div v-if="busy">
              <i class="fa fa-spinner fa-spin text-primary"></i>
            </div>
            <div v-else>
              <span class="text-primary" v-html="message"></span>
            </div>
          </b-col>
          <b-col class="text-right" cols="8">
            <b-button squared size="sm" variant="primary" @click="saveit">
              <i
                :class="
                  busy ? `fa fa-refresh ml-1 fa-spin` : `fa fa-check ml-1`
                "
              ></i>
              Save It
            </b-button>
          </b-col>
        </b-row>
      </b-card-footer>
    </b-card>
  </div>
</template>

<script>
import gql from "graphql-tag";

function isNumeric(value) {
  return /^-?\d+$/.test(value);
}

export default {
  name: "profile",
  data() {
    return {
      title: "My Profile",
      icon: "cil-user",
      busy: false,
      changed: false,
      options: {
        debounce: 500,
      },
      message: "",
      userbeat: "60",
      beats: ["30", "60", "90"],
      row: 15,
      rows: ["5", "10", "15", "20", "50"],
      password_old: null,
      password_old_valid: false,
      password_new1: null,
      password_new1_valid: false,
      password_new2: null,
      password_new2_valid: false,
      avatarb64: "",
      avatarfile: null,
      logo: "",
      logofile: null,
      uploading: false,
      mobile_validnumber: false,
      mobile_validpin: null,
      countries: [],
      titles: ["Mr", "Mrs", "Ms", "Miss", "Dr"],
      item: {
        id: "",
        email: "",
        initials: "",
        title: "",
        firstname: "",
        lastname: "",
        mobile: "",
        telephone: "",
        extension: "",
        company: "",
        department: "",
        jobtitle: "",
        status: "",
        invited: "",
        lastlogin: "",
        slac: "",
        alternativenames: "",
        avatarb64: "",
      },
    };
  },
  watch: {
    async password_old() {
      if (this.password_old) {
        this.password_old_valid = true;
      } else {
        this.password_old_valid = false;
      }
    },
    async password_new1() {
      if (this.password_old) {
        this.password_new1_valid = true;
      } else {
        this.password_new1_valid = false;
      }
    },
    async password_new2() {
      if (this.password_old) {
        if (this.password_new1 == this.password_new2) {
          this.password_new2_valid = true;
        }
      }
    },
  },
  mounted() {
    this.load();
  },
  activated() {
    this.load();
  },
  computed: {
    readonly() {
      if (this.user.rolename == "client") {
        return true;
      } else {
        return false;
      }
    },
  },
  methods: {
    async load() {
      // this.busy = true;

      let variables = {
        id: this.user.id,
        dateformat: "DD/MM/YY HH:MM",
      };
      console.log("variables", variables);
      try {
        const response = await this.$apollo.query({
          query: gql`
            query users($id: String, $dateformat: String) {
              users(id: $id, dateformat: $dateformat) {
                id
                email
                initials
                title
                firstname
                lastname
                mobile
                telephone
                extension
                company
                department
                jobtitle
                status
                invited
                lastlogin
                slac
                alternativenames
                avatarb64
              }
            }
          `,
          variables,
        });

        this.item = response.data.users[0];
      } catch (error) {
        console.log(error);
      }
      // this.busy = false;
    },
    async sendPIN(number) {
      console.log("Event sendPIN() number is: ", number);
      let payload = { email: this.item.email };
      await this.$apollo.mutate({
        mutation: gql`
          mutation ($email: String!) {
            verifyReq(email: $email) {
              verify_id
            }
          }
        `,
        variables: payload,
      });
    },
    async checkPIN(number, PIN) {
      console.log("Event checkPIN() number is: ", number, ", PIN: ", PIN);
      let payload = { email: this.item.email, pin: PIN };
      let result = await this.$apollo.mutate({
        mutation: gql`
          mutation ($email: String!, $pin: String) {
            verifyPin(email: $email, pin: $pin) {
              verify_id
            }
          }
        `,
        variables: payload,
      });
      console.log(result.data.verifyPin);
      this.mobile_validpin = false;
      if (result.data.verifyPin) {
        if (result.data.verifyPin.verify_id == null) {
          this.mobile_validpin = true;
        }
      }
    },
    validNumber(state) {
      console.log("Event validNumber() number is: ", state);
      this.mobile_validnumber = state;
    },
    async saveit() {
      this.busy = true;

      let update = this.cleanit(this.item);
      delete update.lastlogin;
      delete update.slac;

      if (this.password_new2_valid) {
        update.password = btoa(this.password_new2);
      }

      let variables = { rows: [update] };
      console.log("variables", variables);

      try {
        const response = await this.$apollo.mutate({
          mutation: gql`
            mutation setup_users_save($rows: [setup_users_input]) {
              setup_users_save(rows: $rows) {
                id
              }
            }
          `,
          variables,
        });
        console.log(response);
        this.message = "<span class='text-primary'>Saved it.</span>";
      } catch (error) {
        this.message = "<span class='text-danger'>" + error.message + "</span>";
      }

      this.busy = false;
    },

    isChanged() {
      //this.item.valid = this.formValid();
      this.changed = true;
    },
    phonenumber(e) {
      console.log(e);
    },
    async upload() {
      let data = await this.$helpers.getBase64(this.avatarb64);

      this.busy = true;
      // let variables = {
      //   files: fileuploads,
      // };
      // try {
      //   const response = await this.$apollo.mutate({
      //     mutation: gql`
      //       mutation bspupload($files: [FileUpload_input]) {
      //         bspupload(files: $files)
      //       }
      //     `,
      //     variables,
      //   });

      //   this.message =
      //     "<span class='text-primary'>" + response.data.bspupload + "</span>";
      // } catch (error) {
      //   this.message = "<span class='text-danger'>" + error + "</span>";
      // }
      this.busy = false;
    },
    async onAvatarChange(e) {
      var files = e.target.files || e.dataTransfer.files;
      console.log(e);
      if (!files.length) return;
      // let data = await this.$helpers.getBase64(this.files[0])
      console.log(data);
      this.changed = true;
    },
  },
};
</script>

<style lang="scss">
.nav {
  padding-right: 5px !important;
}
.w-26 {
  width: 26% !important;
}

.picture-container {
  position: relative;
  cursor: pointer;
  text-align: center;

  .description {
    margin: 0;
    margin-bottom: 0.5rem;
  }
}
.picture_avatar {
  width: 106px;
  height: 106px;
  //background-color: #999999;
  background-color: white;
  border: 2px solid #cccccc;
  color: #ffffff;
  border-radius: 50%;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;

  &:hover {
    border-color: #2ca8ff;
  }
}
.picture_logo {
  width: 160px;
  height: 106px;
  // background-color: #999999;
  background-color: white;
  border: 2px solid #cccccc;
  color: #ffffff;
  margin: 5px auto;
  overflow: hidden;
  transition: all 0.2s;
  -webkit-transition: all 0.2s;

  &:hover {
    border-color: #2ca8ff;
  }
}

.picture_avatar input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}

.picture_logo input[type="file"] {
  cursor: pointer;
  display: block;
  height: 100%;
  left: 0;
  opacity: 0 !important;
  position: absolute;
  top: 0;
  width: 100%;
}

.avatar-src {
  width: 100%;
}
.logo-src {
  width: 100%;
}
</style>